import api from "@/api/axiosConfig.js";
import { handleSuccessResponse, handleErrorResponse } from '@/api/apiUtils.js';

const MODULE_NAME = 'BROWSER_API';

const createBrowserAPI = (base) => ({

  status_get: async (showNotification = false) => {
    try {
      const response = await api.get(`${base}/status`);
      return handleSuccessResponse(response, MODULE_NAME, 'Получить статус', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'получить статус');
    }
  },

  start_post: async (useProxy = true, showNotification = true) => {
    try {
      const response = await api.post(`${base}/start`, { use_proxy: useProxy });
      return handleSuccessResponse(response, MODULE_NAME, 'Запустить браузер', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'запустить браузер');
    }
  },

  stop_post: async (showNotification = true) => {
    try {
      const response = await api.post(`${base}/stop`);
      return handleSuccessResponse(response, MODULE_NAME, 'Остановить браузер', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'остановить браузер');
    }
  },

  restart_post: async (useProxy = null, showNotification = true) => {
    try {
      const response = await api.post(`${base}/restart`, { use_proxy: useProxy });
      return handleSuccessResponse(response, MODULE_NAME, 'Перезапустить браузер', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'перезапустить браузер');
    }
  },

  logs_get: async (sinceId = 0, showNotification = false) => {
    try {
      const response = await api.get(`${base}/logs`, { params: { since_id: sinceId, limit: 500 } });
      return handleSuccessResponse(response, MODULE_NAME, 'Получить логи', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'получить логи');
    }
  },

  product_query_post: async (productId, showNotification = false) => {
    try {
      const response = await api.post(`${base}/query/product`, { productId });
      return handleSuccessResponse(response, MODULE_NAME, 'Запросить товар', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'запросить товар');
    }
  },

  position_query_post: async (productId, query, showNotification = false) => {
    try {
      const response = await api.post(`${base}/query/position`, { productId, query });
      return handleSuccessResponse(response, MODULE_NAME, 'Запросить позицию', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'запросить позицию');
    }
  },

  category_query_post: async (productId, categoryUrl, showNotification = false) => {
    try {
      const response = await api.post(`${base}/query/category`, { productId, categoryUrl });
      return handleSuccessResponse(response, MODULE_NAME, 'Запросить позицию в категории', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'запросить позицию в категории');
    }
  },

  compare_query_post: async (productId, showNotification = false) => {
    try {
      const response = await api.post(`${base}/query/compare`, { productId });
      return handleSuccessResponse(response, MODULE_NAME, 'Проверить сравнение', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'проверить сравнение');
    }
  },

  recommendations_query_post: async (productId, showNotification = false) => {
    try {
      const response = await api.post(`${base}/query/recommendations`, { productId });
      return handleSuccessResponse(response, MODULE_NAME, 'Запросить рекомендации', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'запросить рекомендации');
    }
  },

  scan_query_post: async (productId, competitorIds, showNotification = false) => {
    try {
      const response = await api.post(`${base}/query/scan`, { productId, competitorIds });
      return handleSuccessResponse(response, MODULE_NAME, 'Проверить конкурентов', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'проверить конкурентов');
    }
  },

  mutual_query_post: async (productId, showNotification = false) => {
    try {
      const response = await api.post(`${base}/query/mutual`, { productId });
      return handleSuccessResponse(response, MODULE_NAME, 'Взаимные рекомендации', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'найти взаимные рекомендации');
    }
  },

  queue_get: async (showNotification = false) => {
    try {
      const response = await api.get(`${base}/queue`, { params: { limit: 100 } });
      return handleSuccessResponse(response, MODULE_NAME, 'Получить очередь', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'получить очередь');
    }
  },

  queue_item_get: async (requestId, showNotification = false) => {
    try {
      const response = await api.get(`${base}/queue/${requestId}`);
      return handleSuccessResponse(response, MODULE_NAME, 'Получить запрос из очереди', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'получить запрос из очереди');
    }
  },

  rolling_restart_start_post: async (intervalSeconds = 180, idleOnly = true, showNotification = true) => {
    try {
      const response = await api.post(`${base}/rolling-restart/start`, { interval_seconds: intervalSeconds, idle_only: idleOnly });
      return handleSuccessResponse(response, MODULE_NAME, 'Авто-рестарт включён', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'включить авто-рестарт');
    }
  },

  rolling_restart_stop_post: async (showNotification = true) => {
    try {
      const response = await api.post(`${base}/rolling-restart/stop`);
      return handleSuccessResponse(response, MODULE_NAME, 'Авто-рестарт выключен', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'выключить авто-рестарт');
    }
  },
});

export const forwardAPI = {
  get: async () => {
    try {
      const response = await api.get('/browser/forward');
      return handleSuccessResponse(response, MODULE_NAME, 'Получить перенаправление', false);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'получить перенаправление');
    }
  },
  set: async (enabled) => {
    try {
      const response = await api.post('/browser/forward', { enabled });
      return handleSuccessResponse(response, MODULE_NAME, enabled ? 'Запросы перенаправляются на удалённые' : 'Перенаправление выключено', true);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'изменить перенаправление');
    }
  },
};

export const browserAPI = createBrowserAPI('/browser');
export const remoteBrowserAPI = createBrowserAPI('/browser/remote');
